export const baseformAttrs = (span = 12, gutter: any = 10) => ({
  col: {
    span
  },
  row: {
    gutter
  }
})
export const ID_COLUMN = { title: 'ID', dataIndex: 'id', width: 200 }
